// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.user-submit-bar-container {
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100; /* Ensures it's always on top */
  background-color: white; /* To make sure it’s visible */
}

.user-submit-bar-content-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.user-submit-bar-text-group {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user-submit-bar-typography {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
}

.user-submit-bar-picks {
  margin-left: 8px;
}

.user-submit-bar-tiebreaker-label {
  margin-left: 16px !important;
}

.user-submit-bar-icon {
  margin-left: 8px;
}

.user-submit-bar-button-group {
  display: flex;
  justify-content: center;
  gap: 24px;
}

.user-submit-bar-cancel-button {
  background-color: #E5E5E5 !important;
  color: #002129 !important;
  border: none;
  /* Ensuring no hover effect */
}
.user-submit-bar-cancel-button:hover {
  background-color: #E5E5E5;
}`, "",{"version":3,"sources":["webpack://./src/components/GamePageComponents/SubmitBars/UserSubmitBar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA,EAAA,+BAAA;EACA,uBAAA,EAAA,8BAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAEJ;;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;;AACE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AAEJ;;AACE;EACE,gBAAA;AAEJ;;AACE;EACE,4BAAA;AAEJ;;AACE;EACE,gBAAA;AAEJ;;AACE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAEJ;;AACE;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;EAEA,6BAAA;AACJ;AAAI;EACE,yBAAA;AAEN","sourcesContent":[".user-submit-bar-container {\n    padding: 16px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 100; /* Ensures it's always on top */\n    background-color: white; /* To make sure it’s visible */\n  }\n\n  .user-submit-bar-content-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n  }\n  \n  .user-submit-bar-text-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n  \n  .user-submit-bar-typography {\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: normal;\n  }\n  \n  .user-submit-bar-picks {\n    margin-left: 8px;\n  }\n  \n  .user-submit-bar-tiebreaker-label {\n    margin-left: 16px !important;\n  }\n  \n  .user-submit-bar-icon {\n    margin-left: 8px;\n  }\n  \n  .user-submit-bar-button-group {\n    display: flex;\n    justify-content: center;\n    gap: 24px;\n  }\n  \n  .user-submit-bar-cancel-button {\n    background-color: #E5E5E5 !important;\n    color: #002129 !important;\n    border: none;\n  \n    /* Ensuring no hover effect */\n    &:hover {\n      background-color: #E5E5E5;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
